import setDefaultOptions from 'date-fns/setDefaultOptions';
export async function setDefaultOptionsDateFns(locale) {
    let dateFnsLocale;
    try {
        const basicLocale = await import(`date-fns/locale/${locale}/index.js`);
        dateFnsLocale = basicLocale;
    }
    catch (error) {
        try {
            const fallbackLocale = await import(`date-fns/locale/${locale.substring(0, 2)}/index.js`);
            dateFnsLocale = fallbackLocale;
        }
        catch (error) { }
    }
    finally {
        if (!dateFnsLocale) {
            dateFnsLocale = await import('date-fns/locale/en-GB');
        }
        if (dateFnsLocale?.default) {
            setDefaultOptions({
                locale: dateFnsLocale.default,
            });
        }
    }
}
